package com.cs.ejobin.web

import com.cs.ejobin.navigation.Screen
import kotlinx.browser.window

fun startScreenFromUrl(): Screen {
    return when (window.location.pathname) {
        "/checkout/success" -> Screen.CheckoutSuccess
        "/checkout/cancel" -> Screen.CheckoutCancel
        else -> Screen.Login
    }
}